/*
 * Title: Successfull/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Successfully sign up popup.
 * Date: 12 Oct 2023
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React, {
    Fragment,
    forwardRef,
    useImperativeHandle,
    useState,
  } from "react";
  import { Dialog, Transition } from "@headlessui/react";
  import {QrScanner} from '@yudiel/react-qr-scanner';
import Loader from "@components/Loader";

  
  const Notification = forwardRef((props, ref) => {
    const [visible, setVisible] = useState(false);
    const [isLoading, setIsLoading]: any = useState(false);
  
    useImperativeHandle(ref, () => ({
      open(data) {
        setVisible(true);
        setIsLoading(false);
        const timer = setTimeout(() => setVisible(false), 120000);
        return () => clearTimeout(timer);
      },
      close() {
        setVisible(false);
      },
    }));

    const direction = "bottom";
  
      return (
        <Transition appear show={visible} as={Fragment}>
        <Dialog as="div" className={`relative z-50 ${direction === "bottom" ? "overflow-hidden" : "overflow-y-hidden"}`} onClose={()=> setVisible(false)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-80" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden">
            
            <div className={`flex justify-center min-h-full text-center ${direction === "bottom" ? "sm:px-10 items-end": "p-10 items-center"}`}>
                <Transition.Child
                  as={Fragment}
                  // enter={`${direction !== "bottom" ?"ease-out duration-300":"transform transition ease-in-out duration-700"}`}
                  // enterFrom={`${direction !== "bottom" ?"opacity-0 scale-95":"translate-y-full"}`}
                  // enterTo={`${direction !== "bottom" ?"opacity-100 scale-100":"translate-y-0"}`}
                  // leave={`${direction !== "bottom" ?"ease-in duration-200":"transform transition ease-in-out duration-700"}`}
                  // leaveFrom={`${direction !== "bottom" ?"opacity-100 scale-100":"translate-y-0"}`}
                  // leaveTo={`${direction !== "bottom" ?"opacity-0 scale-95":"translate-y-full"}`}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                 <Dialog.Panel className={`w-screen max-w-[550px] h-auto min-h-[331px]  transform overflow-hidden  ${direction === "bottom" ? "rounded-t-2xl pb-5": "rounded-2xl"} background px-2 text-center align-middle shadow-xl transition-all`}>
                  <div className={`mt-[85px]`}>
                    {!isLoading ?
                    <QrScanner
                        onDecode={(result) => {
                            if(result){
                                setIsLoading(true);
                                const timer = setTimeout(() => {
                                  window.location.href = result;
                                }, 3000);
                                return () => clearTimeout(timer);
                                
                            
                            }
                        }}
                        onError={(error) => setIsLoading(false)}
                        constraints={{facingMode: 'environment'}}
                    />: <Loader /> }


                    <button
                        onClick={() => setVisible(false)}
                        className="font-medium bg-tile rounded-full text-button-color w-full max-w-[300px] mx-auto h-[41px] flex items-center justify-center my-[50px]"
                      >
                        Close
                      </button>
                    
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      );
  });
  export default Notification;
  